import { DownloadAppPlatform } from 'shared/types/download-app-platform';
import { UAParser } from 'ua-parser-js';

// The Play listing floor: the app's minSdkVersion is 31.
const MIN_ANDROID_VERSION = 12;

const getAndroidPlatform = (
  version: string | undefined,
  deviceType: string | undefined,
): DownloadAppPlatform | null => {
  if (deviceType !== 'mobile') {
    return null;
  }

  const majorVersion = parseInt(version ?? '', 10);
  if (Number.isNaN(majorVersion) || majorVersion < MIN_ANDROID_VERSION) {
    return null;
  }

  return DownloadAppPlatform.Android;
};

export const getDownloadAppPlatform =
  async (): Promise<DownloadAppPlatform | null> => {
    try {
      // Chrome freezes the UA-string Android version at 10; the real one only comes from client hints.
      const { os, device } = await new UAParser().getResult().withClientHints();

      if (device.model === 'iPhone') {
        return DownloadAppPlatform.Ios;
      }

      if (os.name === 'Android') {
        return getAndroidPlatform(os.version, device.type);
      }

      return null;
    } catch {
      // Client hints can be denied by permissions policy; unknown means "use the web app".
      return null;
    }
  };
